import {policyApiFetch} from "./ApiService.js";
import {getPolicyPeopleDetailUrl} from "./EndpointService.js";


export const getPolicyholderDetail = async (token_arg, id) => {
    try {
        return await policyApiFetch(`${getPolicyPeopleDetailUrl}/${id}`, token_arg);
    } catch (error) {
        return null;
    }
};

export const getPolicyholderPolicies = async (token_arg, id, total) => {
    let url = `${getPolicyPeopleDetailUrl}/${id}/policies`;
    if(total) url += `?per_page=${total}`;
    try {
        return await policyApiFetch(url, token_arg);
    } catch (error) {
        return null;
    }
};

export const getPolicyholderBankRef = async (token_arg, id) => {
    try {
        return await policyApiFetch(`${getPolicyPeopleDetailUrl}/${id}/bank_ref`, token_arg);
    } catch (error) {
        return null;
    }
};
